import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { useSessionContext } from '../../../../../../../../contexts/SessionContext';
import { ExtendedListing } from '../../../../../../../../models/Listing';
import { Organization } from '../../../../../../../../types/api.graphql';
import OrganizationDropdown from '../../common';
import VehicleInformation from '../../VehicleInformation/VehicleInformation';
import { Container, EmailInput } from './ShareWithEmailStep.styles';

interface ShareWithEmailStepProps {
  listing: ExtendedListing;
  email: string;
  setEmail: (email: string) => void;
  organizationFrom: Organization;
  setOrganizationFrom: (organization: Organization) => void;
}

const ShareWithEmailStep = ({
  listing,
  email,
  setEmail,
  organizationFrom,
  setOrganizationFrom,
}: ShareWithEmailStepProps) => {
  // Dependencies
  const { t } = useTranslation();
  const { me } = useSessionContext();

  // Derived states
  const availableOrgs = me?.organizations;

  const displayShareFromDropdown = () => {
    if (!listing?.shared) return false;
    if (!listing.receivingUser) return false;

    return true;
  };

  return (
    <Container>
      <VehicleInformation listing={listing} />
      <EmailInput
        label={t('common.email.label')}
        placeholder={t('common.email.placeholder')}
        value={email}
        onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
      />
      {displayShareFromDropdown() ? (
        <OrganizationDropdown
          availableOrganizations={availableOrgs}
          selectedOrganization={organizationFrom}
          setSelectedOrganization={setOrganizationFrom}
          disableDropdown={!!listing?.receivingOrganization}
          label={t('vdp.shareModal.shareFrom')}
          infoTooltip={t('vdp.shareModal.selectOrgFromTooltip')}
        />
      ) : null}
    </Container>
  );
};

export default ShareWithEmailStep;
